import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  InputBase,
  Pagination,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import axios from "axios";
import apiUrl from "../../Config";
import { useNavigate } from "react-router-dom";

const DisplayBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterBookingId, setFilterBookingId] = useState("");
  const [loading, setLoading] = useState(false);

  // Pagination state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const navigate = useNavigate();

  const fetchBookings = async ({ pageNumber, pageSize } = {}) => {
    const params = new URLSearchParams();

    if (pageNumber) params.append("page", page);
    if (pageSize) params.append("pageSize", pageSize);
    setLoading(true);
    try {
      const response = await axios.get(
        apiUrl + `/bookings/allbookings?${params.toString()}`
      );
      if (response?.data?.status === true) {
        setBookings(response?.data?.bookings);
        console.log(response.data.bookings);
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, [page, limit, filterStatus, filterBookingId]);

  const handleEditClick = (id, currentStatus) => {
    setEditingId(id);
    setNewStatus(currentStatus);
  };

  console.log(bookings, "booking");

  const handleSaveClick = async (id) => {
    setLoading(true);
    try {
      await axios.put(`${apiUrl}/bookings/updatebooking/${id}`, {
        bookingStatus: newStatus,
      });
      setEditingId(null);
      fetchBookings();
    } catch (error) {
      console.error("Failed to update status", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  // On pressing Enter in bookingId input, reset page to 1
  const handleBookingIdKeyDown = (e) => {
    if (e.key === "Enter") {
      setPage(1);
      fetchBookings();
    }
  };
  return (
    <Box p={3} mt={2}>
      <Typography variant="h4" gutterBottom>
        Bookings
      </Typography>

      {/* Filters */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            mb: 3,
            alignItems: "center",
          }}
        >
          <InputBase
            placeholder="Search by Booking ID"
            sx={{
              border: "1px solid #ccc",
              px: 2,
              py: 0.5,
              borderRadius: 1,
              width: 200,
            }}
            value={filterBookingId}
            onChange={(e) => setFilterBookingId(e.target.value)}
            onKeyDown={handleBookingIdKeyDown}
          />

          <FormControl size="small" sx={{ minWidth: 150 }}>
            <Select
              value={filterStatus}
              onChange={(e) => {
                setFilterStatus(e.target.value);
                setPage(1);
              }}
              displayEmpty
            >
              <MenuItem value="">All Status</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Success">Success</MenuItem>
              <MenuItem value="Confirmed">Confirmed</MenuItem>
              <MenuItem value="Cancel">Cancelled</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box
          sx={{
            mb: 3,
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
              value={limit}
              onChange={handleLimitChange}
              label="Rows per page"
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      {loading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height={200}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Booking ID</TableCell>
                  {/* <TableCell>User Name</TableCell>
                                <TableCell>Phone</TableCell>
                                <TableCell>Email</TableCell> */}
                  <TableCell>Booking Status</TableCell>
                  <TableCell>Total Amount</TableCell>
                  <TableCell>Booking Date</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bookings.length > 0 ? (
                  bookings.map((booking) => (
                    <TableRow key={booking.id}>
                      <TableCell>{booking.bookingId}</TableCell>
                      {/* <TableCell>{booking.user?.name}</TableCell>
                                        <TableCell>{booking.user?.phone}</TableCell>
                                        <TableCell>{booking.user?.email}</TableCell> */}
                      <TableCell>
                        {editingId === booking.id ? (
                          <FormControl size="small">
                            <Select
                              value={newStatus}
                              onChange={(e) => setNewStatus(e.target.value)}
                            >
                              <MenuItem value="Pending">Pending</MenuItem>
                              <MenuItem value="Success">Success</MenuItem>
                              <MenuItem value="Confirmed">Confirmed</MenuItem>
                              <MenuItem value="Cancel">Cancelled</MenuItem>
                              <MenuItem value="Completed">Completed</MenuItem>
                            </Select>
                          </FormControl>
                        ) : (
                          booking.status
                        )}
                      </TableCell>
                      <TableCell>₹{booking.totalPrice}</TableCell>
                      <TableCell>{booking.bookingDate}</TableCell>
                      <TableCell
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        {editingId === booking.id ? (
                          <IconButton
                            onClick={() => handleSaveClick(booking.id)}
                            title="Save"
                            disabled={loading}
                          >
                            {loading ? (
                              <CircularProgress size={20} color="inherit" />
                            ) : (
                              <SaveIcon />
                            )}
                          </IconButton>
                        ) : (
                          <IconButton
                            onClick={() =>
                              handleEditClick(booking.id, booking.bookingStatus)
                            }
                            title="Edit"
                          >
                            <EditIcon />
                          </IconButton>
                        )}

                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() =>
                            navigate(`/booking-details/${booking.id}`)
                          }
                          sx={{ ml: 1 }}
                        >
                          View More
                        </Button>
                        <Box
                          sx={{
                            visibility:
                              booking.status === "pending"
                                ? "visible"
                                : "hidden",
                          }}
                        >
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() =>
                              navigate(`/assign-technician/${booking.id}`)
                            }
                            sx={{ ml: 1 }}
                          >
                            Assign Tech
                          </Button>
                        </Box>
                        {/* {booking.status === "pending" && (
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() =>
                              navigate(`/assign-technician/${booking.id}`)
                            }
                            sx={{ ml: 1 }}
                          >
                            Assign Tech
                          </Button>
                        )} */}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      No bookings found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
              showFirstButton
              showLastButton
              siblingCount={0}
              boundaryCount={1}
              sx={{
                "& .MuiPaginationItem-root": {
                  height: 30,
                  minWidth: 30,
                  fontSize: "1rem",
                  marginTop: "10px",
                },
              }}
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default DisplayBookings;
